// The one place the legal entity is written down. The terms, the colophon block
// and the privacy notice all read from here, so the registration details can
// never drift apart across three pages.
//
// Art. 3:15d BW (the Dutch implementation of the e-Commerce Directive) requires
// a commercial site to make the trader's identity, address, contact details,
// chamber of commerce number and VAT number easily, directly and permanently
// accessible. A footer link to a page carrying all of it satisfies that; it does
// not have to sit on every page.
//
// NOT DEPLOYED WHILE THE PLACEHOLDERS ARE IN. Publishing an invented KvK number
// is worse than publishing none, so these four values come from Sam before this
// goes live.
// Verified against the public Handelsregister on 24 Aug 2026 (KvK search on
// the number Sam supplied). Registered trade names are "Gemini Marketing" and
// "Flywheel Studio"; "sunbedly" is not registered as a handelsnaam yet — Sam
// can add it for free via KvK online, after which visitors' brand and the
// register match.
export const COMPANY = {
  /** Registered trade name shown as the entity behind the brand. Sam added
   *  "sunbedly" as a handelsnaam under this KvK number on 24 aug 2026, so the
   *  brand visitors see and the register now carry the same name. */
  legalName: "sunbedly",
  /** What visitors see. Register this as a handelsnaam so the two match. */
  tradeName: "sunbedly",
  legalForm: "eenmanszaak",
  // NO street and NO postcode, on purpose (Sam, 30 Sep 2026): the registered
  // address is a home address, so it appears nowhere on the site, not in the
  // structured data either. City, KvK, VAT and email stay public.
  city: "Nijmegen",
  country: "Netherlands",
  kvk: "95627960",
  vat: "NL005166570B27",
  email: "hello@sunbedly.com",
} as const;

/** True once every required field carries a real value. */
export const COMPANY_READY = !Object.values(COMPANY).some((v) =>
  v.startsWith("INVULLEN_"),
);

export function addressLines(): string[] {
  return [COMPANY.city, COMPANY.country];
}
